import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    getMockupGenerationLogs as getMockupGenerationLogsApi,
    getAllMockupGenerationLogs,
    getMockupGenerationLogByEventId,
    IMockupGenerationLogsQueryParams,
} from '../../api/mockupGenerationLogs';
import store from '../../store';
import { setNotifications } from '../slices/notifications';

const handleThunkError = (error: any, rejectWithValue: (value: unknown) => any) => {
    store.dispatch(setNotifications({ text: error.message, type: 'error' }));
    return rejectWithValue(error.message);
};

export const getMockupGenerationLogs = createAsyncThunk(
    'mockupGenerationLogs/getMockupGenerationLogs',
    async (queryParams: IMockupGenerationLogsQueryParams, { rejectWithValue }) => {
        try {
            return await getMockupGenerationLogsApi(queryParams);
        } catch (error: any) {
            return handleThunkError(error, rejectWithValue);
        }
    }
);

export const getMockupGenerationLogsAnalytics = createAsyncThunk(
    'mockupGenerationLogs/getMockupGenerationLogsAnalytics',
    async (queryParams: IMockupGenerationLogsQueryParams, { rejectWithValue }) => {
        try {
            return await getAllMockupGenerationLogs(queryParams);
        } catch (error: any) {
            return handleThunkError(error, rejectWithValue);
        }
    }
);

export const getMockupGenerationLog = createAsyncThunk(
    'mockupGenerationLogs/getMockupGenerationLog',
    async (eventId: string | number, { rejectWithValue }) => {
        try {
            const log = await getMockupGenerationLogByEventId(eventId);
            if (!log) throw new Error(`Generation log for event ${eventId} not found`);
            return log;
        } catch (error: any) {
            return handleThunkError(error, rejectWithValue);
        }
    }
);
